/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { PersonApiConfiguration } from '../person-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PemPersonWithConsentsResponseDtoDto } from '../models/pem-person-with-consents-response-dto-dto';


/**
 * the Person with consents API
 */
@Injectable({
  providedIn: 'root',
})
export class PersonWithConsentsService extends BaseService {
  constructor(
    config: PersonApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation fetchPersonWithConsents
   */
  static readonly FetchPersonWithConsentsPath = '/person-consent/{personUID}';

  /**
   * Get details about person and his consents
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fetchPersonWithConsents()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetchPersonWithConsents$Response(params: {

    /**
     * UID of the person for whom consents will be collected
     */
    personUID: string;
    'Accept-Language'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PemPersonWithConsentsResponseDtoDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonWithConsentsService.FetchPersonWithConsentsPath, 'get');
    if (params) {
      rb.path('personUID', params.personUID, {});
      rb.header('Accept-Language', params['Accept-Language'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PemPersonWithConsentsResponseDtoDto>;
      })
    );
  }

  /**
   * Get details about person and his consents
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fetchPersonWithConsents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fetchPersonWithConsents(params: {

    /**
     * UID of the person for whom consents will be collected
     */
    personUID: string;
    'Accept-Language'?: string;
  },
  context?: HttpContext

): Observable<PemPersonWithConsentsResponseDtoDto> {

    return this.fetchPersonWithConsents$Response(params,context).pipe(
      map((r: StrictHttpResponse<PemPersonWithConsentsResponseDtoDto>) => r.body as PemPersonWithConsentsResponseDtoDto)
    );
  }

}
